import { Map } from 'immutable'
import { not } from 'ramda'
import { createReducer } from 'reducers/utils'
import { DEFAULT_DRAWER_WIDTH } from 'utils/drawerConstants'
import { LOCATION_CHANGE } from 'connected-react-router'

import {
  SET_DRAWER_OPENING,
  SET_DRAWER_OPENED,
  SET_DRAWER_CLOSING,
  SET_DRAWER_CLOSED,
  SET_DRAWER_VISIBLE,
  SET_SHOW_DRAWER_MASK,
  SET_DRAWER_WIDTH,
  SET_DRAWER_VISIBLE_WIDTH,
} from 'actions/drawer'

const initialState = Map({
  isDrawerOpening: false,
  isDrawerOpened: false,
  isDrawerClosing: false,
  isDrawerClosed: true,
  isDrawerVisible: false,
  showDrawerMask: false,
  drawerWidth: DEFAULT_DRAWER_WIDTH,
  visibleWidth: DEFAULT_DRAWER_WIDTH,
})

const handlers = {
  [SET_DRAWER_OPENING]: setDrawerOpening,
  [SET_DRAWER_OPENED]: setDrawerOpened,
  [SET_DRAWER_CLOSING]: setDrawerClosing,
  [SET_DRAWER_CLOSED]: setDrawerClosed,
  [SET_DRAWER_VISIBLE]: setDrawerVisible,
  [SET_SHOW_DRAWER_MASK]: setShowDrawerMask,
  [SET_DRAWER_WIDTH]: setDrawerWidth,
  [SET_DRAWER_VISIBLE_WIDTH]: setDrawerVisibleWidth,
  [LOCATION_CHANGE]: hideDrawerOnNavigation,
}

export default createReducer(initialState, handlers)

function setDrawerOpening(state) {
  return state.merge(
    Map({
      isDrawerClosed: false,
      isDrawerOpening: true,
    })
  )
}

function setDrawerOpened(state) {
  return state.merge(
    Map({
      isDrawerOpening: false,
      isDrawerOpened: true,
    })
  )
}

function setDrawerClosing(state) {
  return state.merge(
    Map({
      isDrawerOpened: false,
      isDrawerClosing: true,
    })
  )
}

function setDrawerClosed(state) {
  return state.merge(
    Map({
      isDrawerClosing: false,
      isDrawerClosed: true,
    })
  )
}

function setDrawerVisible(state, { visible }) {
  return state.merge(
    Map({
      ...(not(visible) && { showDrawerMask: false }),
      isDrawerVisible: visible,
    })
  )
}

function setShowDrawerMask(state, { visible }) {
  return state.set('showDrawerMask', visible)
}

function setDrawerWidth(state, { width }) {
  return state.set('drawerWidth', width)
}

function setDrawerVisibleWidth(state, { width }) {
  return state.set('visibleWidth', width)
}

function hideDrawerOnNavigation(state) {
  return state.merge(
    Map({
      isDrawerVisible: false,
      showDrawerMask: false,
    })
  )
}
